export default __webpack_public_path__ + "static/media/750.095c3c2a.png";